import { css } from "@emotion/react";
// CSS 코드를 작성하는 모듈 가져옴

export const GlobalStyles = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  // 모든 요소에 CSS 적용함
`;